import { Component, ViewChild } from '@angular/core';
import { AuthService } from '../../../../services/auth.service';
import { firstValueFrom, Subscription } from 'rxjs';
import {
	TokenPack,
	AuthService as MtLibsAuthService,
	ClientService as MtLibsClientService,
} from '@mira-avant/mtlibs';
import { AngularModule } from '../../../../modules/angular.module';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { EnvHelper, Stage } from '../../../../utils/env.helper';
import { MessengerService } from '../../../../services/messenger.service';
import { ClientService } from '../../../../services/client.service';

@Component({
	selector: 'app-content-app-iframe',
	standalone: true,
	imports: [AngularModule],
	templateUrl: './content-app-iframe.component.html',
	styleUrl: './content-app-iframe.component.scss',
})
export class ContentAppIframeComponent {
	@ViewChild('iframe') private iframe: any;
	public token: string | undefined;
	private sub: Subscription | undefined;
	private auth: MtLibsAuthService = new MtLibsAuthService();
	private mtLibsClientService: MtLibsClientService = new MtLibsClientService();
	public safeUrl: SafeResourceUrl | undefined;

	constructor(
		private authService: AuthService,
		private sanitizer: DomSanitizer,
		private messenger: MessengerService,
		private clientService: ClientService,
	) {
		this.sub = this.authService.tokenPack$.subscribe((tokenPack: TokenPack | null) => {
			this.token = tokenPack ? tokenPack.token : undefined;
		});
	}

	private generateSafeUrl(): SafeResourceUrl {
		const stage: Stage = EnvHelper.identifyStageBasedOnUrl();

		let contentUrl: string = '';

		// https://content.dev.metabi-poc-hub.com to https://content.dev.mira-learn.com
		// https://content.staging.metabi-poc-hub.com to https://content.staging.mira-learn.com
		// https://content.metabi-poc-hub.com to https://content.mira-learn.com

		if (Stage.DEV === stage) {
			contentUrl = 'https://content.dev.mira-learn.com';
		} else if (Stage.STAGING === stage) {
			contentUrl = 'https://content.staging.mira-learn.com';
		} else {
			contentUrl = 'https://content.mira-learn.com';
		}

		return this.sanitizer.bypassSecurityTrustResourceUrl(`${contentUrl}`);
	}

	ngOnInit() {
		this.safeUrl = this.generateSafeUrl();
	}

	ngAfterViewInit() {
		this.messenger.init(this.iframe.nativeElement.contentWindow);

		this.messenger.message$.subscribe((message: string) => {
			console.info('Angular received message:', message);
		});

		this.mtLibsClientService.listenForGetClientSubdomain(async () => {
			const subdomain: string = await firstValueFrom(this.clientService.selectedClient$).then(client => client?.subdomain || '...missing...');
			return subdomain;
		});

		this.auth.listenForGetTokenCode(() => {
			return this.authService.createTokenPackCode();
		});
	}

	ngOnDestroy() {
		this.sub?.unsubscribe();
	}
}
